// Flow B stage 4: codes out, codes used, registrations by day. The nightly batch is gone (the
// agent reads live), so "tonight's batch" is replaced by the outbox's health.
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api.js";
import { StatStrip, PageHead, Notice, fmtWhen } from "./ui.jsx";

export default function MonitoringPage() {
  const [m, setM] = useState(null);
  const [error, setError] = useState(null);
  const load = async () => { try { setM(await api("/backoffice/monitoring")); setError(null); } catch (err) { setError(err.message); } };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  if (error) return <Notice tone="bad">{error}</Notice>;
  if (!m) return <PageHead title="Monitoring" sub="Loading…" />;
  const days = m.byDay.filter((d, i, a) => d.registrations || d.codes || d.sent || i >= a.length - 7);
  const max = Math.max(1, ...days.map(d => Math.max(d.registrations, d.sent)));
  const ok = m.outbox.dead === 0 && m.outbox.stale === 0;
  return (
    <>
      <PageHead title="Monitoring" sub="Codes out, codes used, and whether the hand-offs are flowing. Codes reach the agent the moment they are issued; nothing waits for a nightly file." />
      <StatStrip big items={[
        { k: "Codes issued", v: m.codes.issued, sub: `${m.codes.driving} driving · ${m.codes.flying} flying` },
        { k: "Booked by the agent", v: m.codes.booked, sub: `of ${m.codes.issued}`, color: "#786018" },
        { k: "Registered", v: m.invitations.registered, sub: `of ${m.invitations.sent} invited and sent`, color: "#2f6b3a" },
        { k: "Badges", v: m.badges.confirmed, sub: `${m.badges.total} total · ${m.badges.failed} failed`, color: m.badges.failed ? "#8a2a1d" : undefined },
      ]} />
      <div className="bo-stats" style={{ marginTop: 14 }}>
        {[
          { k: "Invited", v: m.invitations.invited }, { k: "Not yet sent", v: m.invitations.unsent }, { k: "Opened", v: m.invitations.opened },
          { k: "Bounced", v: m.invitations.bounced, color: m.invitations.bounced ? "#8a2a1d" : undefined }, { k: "Needs a human", v: m.needsHuman, color: m.needsHuman ? "#786018" : undefined },
        ].map(s => <div className="bo-stat" key={s.k}><div className="k">{s.k}</div><div className="v" style={s.color ? { color: s.color } : undefined}>{s.v}</div></div>)}
      </div>

      <h2 className="bo-h2">Registrations by day</h2>
      <div className="bo-table days">
        <div className="bo-th"><div>Day</div><div>Registrations</div><div>Codes</div><div>Invitations sent</div><div /></div>
        {days.map(d => (
          <div className="bo-tr" key={d.day}>
            <div className="mono">{new Date(d.day + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</div>
            <div className="mono">{d.registrations}</div><div className="mono">{d.codes}</div><div className="mono">{d.sent}</div>
            <div className="bars"><span className="bar sent" style={{ width: `${(d.sent / max) * 100}%` }} /><span className="bar reg" style={{ width: `${(d.registrations / max) * 100}%` }} /></div>
          </div>
        ))}
      </div>
      <div className="bo-count">Lighter bar: invitations sent · darker bar: registrations. Last 30 days, empty days hidden.</div>

      <h2 className="bo-h2">Hand-offs</h2>
      <div className="bo-panel">
        {ok ? <Notice tone="ok">Flowing. Nothing stuck, nothing dead. Last delivery {m.outbox.lastSentAt ? fmtWhen(m.outbox.lastSentAt) : "none yet"}.</Notice>
            : <Notice tone="bad">{m.outbox.dead} dead · {m.outbox.stale} stuck over 10 minutes · {m.outbox.queued} queued. FocustApps has been alerted; codes already issued are unaffected.</Notice>}
        <div className="muted small">Every code, badge and invitation email is a row in the outbox; a worker delivers them and retries on its own. "Dead" means it gave up after eight tries.</div>
      </div>
    </>
  );
}
